<script>
    import TextDisplay from "./TextDisplay.svelte";
    import DatePicker from "./DatePicker.svelte";
    import FormRow from "./FormRow.svelte";
    import DisplayRow from "./DisplayRow.svelte";
    import FormColumn from "./FormColumn.svelte";

    export let claimant;
    export let disabled = null;

    if (!claimant.initialised) {
        claimant.initialised = true;
	    claimant.allowDoBUpdate = !claimant.dateOfBirth
    }
</script>

<DisplayRow>
    <FormColumn cols="6">
        <TextDisplay label="First name" value={claimant.firstName} />
    </FormColumn>
    <FormColumn cols="6">
        <TextDisplay label="Surname" value={claimant.surname} />
    </FormColumn>
</DisplayRow>

{#if claimant.allowDoBUpdate && !disabled}

    <FormRow>
        <FormColumn cols="3">
            <DatePicker
                required
                disabled={disabled}
                id="e_dateOfBirth"
                label="Date of birth"
                validator={true}
                start={new Date(1924, 0, 1)}
                end={new Date()}
                placeholder="e.g. 01/05/1987"
                bind:formattedSelected={claimant.dateOfBirth}
                openOnClass="calendar-icon" />
        </FormColumn>
    </FormRow>

{:else}

    <DisplayRow>
        <FormColumn cols="3">
            <TextDisplay
                label="Date of birth"
                value={claimant.dateOfBirth} />
        </FormColumn>
    </DisplayRow>

{/if}